'use client';
import { Tooltip } from '@pickleballinc/react-ui';

import { GroupPlayer } from '@/modules/league/new-components/types';

interface StatsTableProps {
  player: GroupPlayer;
  columns: { key: string; label: string; dataKey: keyof GroupPlayer }[];
}

export function StatsTable({ player, columns }: StatsTableProps) {
  return (
    <table className='w-full text-center text-sm text-gray-500'>
      <thead className='border bg-gray-50 text-xs uppercase text-gray-700'>
        <tr>
          {columns.map(({ key, label }) => (
            <Tooltip key={key} placement='top-end'>
              <Tooltip.Trigger asChild>
                <th
                  className={`border py-4 font-normal md:px-6 ${key === 'l' || key === 'h2h dif' || key === 'dif' ? 'bg-leagues-300/10' : ''}`}
                >
                  {key}
                </th>
              </Tooltip.Trigger>
              <Tooltip.Content className='w-22 rounded bg-black bg-black/75 p-2 text-sm text-white'>
                {label}
              </Tooltip.Content>
            </Tooltip>
          ))}
        </tr>
      </thead>
      <tbody>
        <tr className='bg-white'>
          {columns.map(({ dataKey }) => (
            <td
              key={dataKey as string}
              className={`border py-4 md:px-6 ${dataKey === 'TeamDifference_EarnedAgainst' || dataKey === 'TeamHeadToHead_PointDifferenceWithinHeadToHead' || dataKey === 'TeamLosses' ? 'bg-leagues-300/10' : ''}`}
            >
              {dataKey === 'TeamPointDifferencePercentage'
                ? parseFloat(player[dataKey]).toFixed(2)
                : player[dataKey]}
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
}
